export default __webpack_public_path__ + "static/media/Fantasy_10.18934172.png";